import {
  utils,
} from '@ama-sdk/core';
import {
  CheckInFlight,
  Journey,
  TravelerIdentifier,
} from '@dapi/sdk';
import {
  CheckInFlightIdObjectRepository,
  combineCheckInFlightIdObjects,
  combineJourneyElementCommons,
  combineJourneyTravelers,
  createAcceptance,
  createCheckInFlightIdObject,
  createEligibility,
  createJourney,
  createJourneyElement,
  createJourneyTraveler,
  createName,
  createTraveler,
  createTravelerIdentifier,
  JourneyTravelerRepository,
  MockJourneyTraveler,
  MockName,
  RecursivePartial,
} from '@dapi/sdk/spec';
import {
  email,
  phone,
} from './contact';
import {
  globalDob,
} from './dates';

export const jourenyTravelerMock = createJourneyTraveler({
  template: {
    dateOfBirth: new utils.Date(globalDob),
    gender: 'male',
    names: [
      {
        firstName: 'TEST',
        lastName: 'BERNARD',
        title: 'MR'
      }
    ]
  }
});

export const jourenyTravelerMock1 = createJourneyTraveler({
  template: {
    dateOfBirth: new utils.Date(globalDob),
    gender: 'male',
    names: [
      {
        firstName: 'TESTb',
        lastName: 'BERNARD',
        title: 'MR'
      }
    ]
  }
});

export const jourenyTravelerMock2 = createJourneyTraveler({
  template: {
    dateOfBirth: new utils.Date(globalDob),
    gender: 'male',
    names: [
      {
        firstName: 'TESTc',
        lastName: 'BERNARD',
        title: 'MR'
      }
    ]
  }
});

export const travelerPaxType = 'ADT';
export const travelerName: MockName = createName({
  template: {
    firstName: 'Laurent',
    lastName: 'Martin',
    title: 'Mr'
  }
});
export const defaultContactName: MockName = createName({
  template: {
    lastName: 'EDWARDLEWIS'
  }
});

export const journeyTraveler: MockJourneyTraveler = JourneyTravelerRepository.MAN;

export const journeyTravelerIdentifier: TravelerIdentifier = createTravelerIdentifier({
  template: {
    id: journeyTraveler.id,
    traveler: journeyTraveler
  }
});

export const journeyTravelerBlank: MockJourneyTraveler[] = combineJourneyTravelers([
  createTraveler({
    template: {
      passengerTypeCode: 'ADT'
    }
  })
]).items;

export const journeyTraveler2: MockJourneyTraveler = JourneyTravelerRepository.WOMAN;

export const journeyTravelerChd: MockJourneyTraveler = JourneyTravelerRepository.CHD;

export const journeyTravelerInf: MockJourneyTraveler = JourneyTravelerRepository.INF;

export const twoAdtJourneyTravelers: MockJourneyTraveler[] = combineJourneyTravelers([journeyTraveler, journeyTraveler2]).items;

export const blankAdTChdInfJourneyTravelers: MockJourneyTraveler[] = combineJourneyTravelers([
  createJourneyTraveler({
    template: {
      passengerTypeCode: 'ADT'
    }
  }),
  createJourneyTraveler({
    template: {
      passengerTypeCode: 'CHD'
    }
  }),
  createJourneyTraveler({
    template: {
      passengerTypeCode: 'INF'
    }
  })
]).items;
export const filledAdTChdInfJourneyTravelers: MockJourneyTraveler[] = combineJourneyTravelers([
  JourneyTravelerRepository.MAN,
  JourneyTravelerRepository.CHD,
  JourneyTravelerRepository.INF
]).items;

export const namedTraveler: MockJourneyTraveler = createJourneyTraveler({
  template: {
    names: [travelerName],
    passengerTypeCode: travelerPaxType,
    gender: 'male',
    dateOfBirth: new utils.Date(globalDob)
  }
});

export const namedTravelerIdentifier: TravelerIdentifier = createTravelerIdentifier({
  template: {
    id: namedTraveler.id,
    traveler: namedTraveler
  }
});

export const journeyTemplateFourPax: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        passengerTypeCode: 'ADT',
        names: [
          {
            firstName: 'TEST',
            lastName: 'ADT',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        passengerTypeCode: 'CHD',
        names: [
          {
            firstName: 'TEST',
            lastName: 'CHD',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        passengerTypeCode: 'INF',
        names: [
          {
            firstName: 'TEST',
            lastName: 'INF',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        passengerTypeCode: 'ADT',
        names: [
          {
            firstName: 'TEST',
            lastName: 'ADTTEST',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

export const journeyTemplateTwoPax: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TESTb',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

export const journeyTemplateIneligiblePax: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'John',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ],
  journeyElements: combineJourneyElementCommons([
    {
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-0-MOCK'
        }
      }
    },
    {
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-1-MOCK'
        },
        acceptanceEligibility: {
          status: 'ineligible',
          reasons: ['ticketProblem']
        }
      }
    }]).items
};

export const journeyTemplateThreePax: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    jourenyTravelerMock,
    jourenyTravelerMock1,
    jourenyTravelerMock2
  ]
};

export const journeyTemplateMultiPax: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    journeyTraveler2,
    journeyTravelerChd,
    journeyTravelerInf
  ]
};

export const journeyTemplateSingleJourney: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

export const partialAcceptedjourney = createJourney({
  template: {
    ...journeyTemplateTwoPax,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'notAccepted'
        }
      }]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [{
          id: 'JOURNEY-ELEMENT-0-MOCK',
          journeyElement: createJourneyElement()
        }],
        notCheckedInJourneyElements: [{
          id: 'JOURNEY-ELEMENT-1-MOCK',
          journeyElement: createJourneyElement()
        }],
        isAccepted: false,
        isPartial: true
      }
    })
  }
});

export const AllAcceptedjourney = createJourney({
  template: {
    ...journeyTemplateThreePax,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-2-MOCK'
          },
          checkInStatus: 'accepted'
        }
      }]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [{
          id: 'JOURNEY-ELEMENT-0-MOCK',
          journeyElement: createJourneyElement()
        },
        {
          id: 'JOURNEY-ELEMENT-1-MOCK',
          journeyElement: createJourneyElement()
        },
        {
          id: 'JOURNEY-ELEMENT-2-MOCK',
          journeyElement: createJourneyElement()
        }],
        isAccepted: true,
        isPartial: false
      }
    })
  }
});

const checkInFlight: CheckInFlight = {
  acceptanceStatus: 'opened',
  marketingAirlineCode: '6X',
  marketingFlightNumber: '6X001',
  departure: {},
  arrival: {},
  id: 'CHECK-IN-FLIGHT-0-MOCK',
  status: 'cancelled',
  marketingAirline: 'Amadeus'
};

export const cancelledJourney = createJourney({
  template: {
    type: 'standalone',
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN]).items,
    flights: [createCheckInFlightIdObject({
      template: {
        checkInFlight: {
          acceptanceStatus: 'notOpened',
          marketingAirlineCode: '6X',
          marketingFlightNumber: '6X001',
          departure: {},
          arrival: {},
          id: 'CHECK-IN-FLIGHT-0-MOCK',
          status: 'cancelled',
          marketingAirline: 'Amadeus'
        }
      }
    })],
    acceptanceEligibility: createEligibility({
      template: {
        status: 'ineligible',
        eligibilityWindow: {
          closingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() + 24 * 3600 * 1000),
          openingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() - 24 * 3600 * 1000)
        },
        reasons: ['flightGeneralStatus']
      }
    }),
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          acceptanceEligibility: {
            status: 'ineligible',
            reasons: ['flightGeneralStatus']
          }
        }
      }]).items,
    acceptance: {
      isAccepted: false,
      isPartial: false
    }
  }
});

export const cancelledAcceptedJourney = createJourney({
  template: {
    type: 'standalone',
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN]).items,
    flights: [
      {
        id: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInFlight
      }
    ],
    acceptanceEligibility: createEligibility({
      template: {
        status: 'eligible',
        eligibilityWindow: {
          closingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() + 24 * 3600 * 1000),
          openingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() - 24 * 3600 * 1000)
        }
      }
    }),
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          acceptanceEligibility: {
            status: 'eligible'
          }
        }
      }]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-0-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        isAccepted: true,
        isEligibleForVoluntaryDeniedBoarding: false
      }
    })
  }
});

export const journeyWith2Pax = createJourney({
  template: {
    type: 'standalone',
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN,
      JourneyTravelerRepository.WOMAN]).items,
    flights: combineCheckInFlightIdObjects([
      CheckInFlightIdObjectRepository.FRA_NCE]).items,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          }
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          }
        }
      }]).items,
    acceptance: {
      isAccepted: false,
      isPartial: false
    }
  }
});

export const partialAcceptedjourneyFor2Pax = createJourney({
  template: {
    ...journeyWith2Pax,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'notAccepted'
        }
      }
    ]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-0-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        notCheckedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-1-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        isAccepted: false,
        isPartial: true
      }
    })
  }
});

export const notAcceptedJourneyAfterDeletePax = createJourney({
  template: {
    ...journeyWith2Pax,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      }]).items
  }
});

export const acceptedJourneyAfterDeletePax = createJourney({
  template: {
    ...journeyWith2Pax,
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN]).items,
    journeyElements: combineJourneyElementCommons([{
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-0-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted'
      }
    }]).items,
    acceptance: {
      isAccepted: true,
      isPartial: false
    }
  }
});

export const acceptedJourneyAfterDeletePax3 = createJourney({
  template: {
    ...journeyWith2Pax,
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN,
      JourneyTravelerRepository.WOMAN]).items,
    journeyElements: combineJourneyElementCommons([{
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-0-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted'
      }
    },
    {
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-1-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted'
      }
    }]).items,
    acceptance: {
      isAccepted: true,
      isPartial: false
    }
  }
});

export const allAcceptedJourneyFor2Pax = createJourney({
  template: {
    ...journeyWith2Pax,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'accepted'
        }
      }]).items,
    acceptance: createAcceptance({
      template: {
        isAccepted: true,
        isPartial: false
      }
    })
  }
});
